var scoresObject = {};

function getScoreObject(trialRow) {
    var scoreString = window.columnForTrial('score', trialRow);
    
    if(scoreString === "na"){
        return null;
    }

    var scoreObject = {
        group: 'score'
    };

    var scoreRegex = /(\w+:)?((-?\d+)(;-?\d+)*)/gm;
    var matches = scoreRegex.exec(scoreString);

    if(matches[1]) {
        scoreObject.group = matches[1].slice(0, -1);
    }

    var scores = matches[2].split(';');
    var responseOptions =  window.columnForTrial('responseOptions', trialRow).split(';');

    for(var i = 0; i < responseOptions.length; i++) {
       scoreObject[responseOptions[i].trim()] = parseInt(scores[i]);
    }

    return scoreObject;
}

function updateScore(trialRow, response) {
    if(listTrialScores[trialRow] === null) {
        return;
    }

    var currentScoreObject = listTrialScores[trialRow];
    var scoreGroup = currentScoreObject.group;
    var score = currentScoreObject[response] || 0;

    if(window.scoresObject[scoreGroup] === undefined) {
        window.scoresObject[scoreGroup] = score;
    }

    else{
        window.scoresObject[scoreGroup] += score;
    }

    return {
        group: scoreGroup,
        score: score
    };
}

function saveScores(trialRow, response) {
    if(listTrialScores[trialRow] === null){
        window.scores.push("");
        return;
    }
    var currentScoreObject = updateScore(trialRow, response);
    if(currentScoreObject.group === "score"){
        window.scores.push(currentScoreObject.score);
    }
    else{
        window.scores.push(currentScoreObject.group + ':' + currentScoreObject.score);   
    }

}

function getTotalScore() {
    var currentScores = [];
    for(var key in window.scoresObject){
        if(key !== 'score'){
            currentScores.push(key + ':' + window.scoresObject[key]);
        }
        else{
            currentScores.push(window.scoresObject[key]);
        }
        
    }
    return currentScores.join(';');
}